export default __webpack_public_path__ + "static/znajomosc-rynku-350a55b86c635cbb738f08f707229470.png";